var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"u-mt-md"},[_c('AppTitle',{staticClass:"u-mb-md",attrs:{"title":_vm.$t('mantra')}})],1),_c('Query',{attrs:{"query":require('~/graphql/Highlight.gql').Highlights,"limit":10,"initialValue":_vm.highlights,"variables":function (ref) {
	var skip = ref.skip;
	var limit = ref.limit;

	return ({ skip: skip, limit: limit, type: 'MOMENT' });
}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var items = ref.items;
return [_c('AsymetricGrid',{ref:"grid",attrs:{"items":items},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var ratio = ref.ratio;
return [_c('MomentCard',{attrs:{"id":item.id,"slug":item.slug,"img":item.media.src,"ratio":ratio,"title":item.caption,"autoRatio":true,"likes":item.likes,"isActive":_vm.$route.params.slug === item.slug,"type":"MOMENT"},on:{"liked":function($event){item.likes++}}})]}}],null,true)})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }